import { getAccessLabel } from '../utils/access';

const AUTH_STORAGE_KEY = 'portal-authentication';
const TOKEN_STORAGE_KEY = 'portal-auth-token';

function getStorage() {
    return window.sessionStorage;
}

function normalizeSession(authentication) {
    if (!authentication) {
        return null;
    }

    const user = authentication.user || authentication;
    const nome = user.Nome || user.nome || '';
    const sobrenome = user.Sobrenome || user.sobrenome || '';
    const email = user.Email || user.email || '';
    const tipoAcesso = Number(user.TipoAcesso || user.tipoAcesso || 0);

    return {
        token: authentication.token || user.token || '',
        idUsuario: user.idUsuario,
        nome,
        sobrenome,
        email,
        tipoAcesso,
        nomeExibicao: `${nome} ${sobrenome}`.trim() || email
    };
}

const sessionService = {
    save(authentication) {
        const session = normalizeSession(authentication);

        if (!session) {
            return null;
        }

        const storage = getStorage();
        storage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
        storage.setItem(TOKEN_STORAGE_KEY, session.token);
        storage.setItem('userId', session.nomeExibicao || session.email || '');
        storage.setItem('tipoAcesso', String(session.tipoAcesso || 0));
        storage.setItem('partnerId', String(session.idUsuario || ''));

        return session;
    },
    getSession() {
        const rawValue = getStorage().getItem(AUTH_STORAGE_KEY);

        if (!rawValue) {
            return null;
        }

        try {
            return JSON.parse(rawValue);
        } catch (error) {
            this.clear();
            return null;
        }
    },
    getToken() {
        return getStorage().getItem(TOKEN_STORAGE_KEY) || '';
    },
    clear() {
        const storage = getStorage();
        storage.removeItem(AUTH_STORAGE_KEY);
        storage.removeItem(TOKEN_STORAGE_KEY);
        storage.removeItem('userId');
        storage.removeItem('tipoAcesso');
        storage.removeItem('partnerId');
    },
    getAccessLevel() {
        const value = getStorage().getItem('tipoAcesso');
        return Number(value || 0);
    },
    getAccessLabel() {
        return getAccessLabel(this.getAccessLevel());
    },
    getDisplayName() {
        return getStorage().getItem('userId') || '';
    },
    getPartnerId() {
        const value = getStorage().getItem('partnerId');
        return Number(value || 0);
    }
};

export {
    sessionService
};
